import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "cryptpe_consent";
const OPEN_EVENT = "cryptpe:consent-settings";

export const openConsentSettings = () => window.dispatchEvent(new Event(OPEN_EVENT));

const clearAnalyticsState = () => {
  try {
    const domains = ["", `; domain=${window.location.hostname}`, `; domain=.${window.location.hostname.split(".").slice(-2).join(".")}`];
    document.cookie.split(";").forEach((c) => {
      const name = c.split("=")[0].trim();
      if (name === "_ga" || name.startsWith("_ga_") || name.startsWith("ph_")) {
        domains.forEach((d) => { document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d}`; });
      }
    });
    Object.keys(localStorage).forEach((k) => { if (k.startsWith("ph_")) localStorage.removeItem(k); });
    Object.keys(sessionStorage).forEach((k) => { if (k.startsWith("ph_")) sessionStorage.removeItem(k); });
    if (window.posthog?.opt_out_capturing) window.posthog.opt_out_capturing();
  } catch (_) { /* best effort */ }
};

export const ConsentBanner = () => {
  const [visible, setVisible] = useState(() => {
    try { return !localStorage.getItem(KEY); } catch (_) { return false; }
  });
  const [hadAccepted, setHadAccepted] = useState(false);

  useEffect(() => {
    const open = () => {
      try { setHadAccepted(localStorage.getItem(KEY) === "granted"); } catch (_) { /* noop */ }
      setVisible(true);
    };
    window.addEventListener(OPEN_EVENT, open);
    return () => window.removeEventListener(OPEN_EVENT, open);
  }, []);

  if (!visible) return null;

  const decide = (granted) => {
    try { localStorage.setItem(KEY, granted ? "granted" : "denied"); } catch (_) { /* noop */ }
    setVisible(false);
    if (granted) {
      window.__loadAnalytics?.();
    } else if (hadAccepted) {
      clearAnalyticsState();
      window.location.reload();
    }
  };

  return (
    <div
      data-testid="consent-banner"
      role="dialog"
      aria-label="cookie consent"
      className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-[340px] z-[90] rounded-2xl border border-zinc-800 bg-zinc-950/95 backdrop-blur-md shadow-[0_8px_40px_rgba(0,0,0,0.6)] p-4 animate-in fade-in slide-in-from-bottom-3 duration-300"
    >
      <div className="mono text-[9.5px] uppercase tracking-[0.15em] text-zinc-600 mb-1.5">cookies</div>
      <p className="text-[12px] text-zinc-400 leading-relaxed">
        analytics cookies help us improve the site. they load only if you accept.{" "}
        <Link to="/cookies" data-testid="consent-policy-link" className="text-zinc-300 underline underline-offset-2 hover:text-white transition-colors">
          policy
        </Link>
      </p>
      <div className="flex gap-2 mt-3">
        <button
          type="button"
          data-testid="consent-reject-btn"
          onClick={() => decide(false)}
          className="flex-1 px-3 py-2 rounded-full border border-zinc-800 text-zinc-300 text-[11.5px] font-bold hover:bg-white/5 hover:border-zinc-600 transition-colors"
        >
          reject
        </button>
        <button
          type="button"
          data-testid="consent-accept-btn"
          onClick={() => decide(true)}
          className="flex-1 px-3 py-2 rounded-full bg-white text-black text-[11.5px] font-bold hover:bg-zinc-200 transition-colors"
        >
          accept
        </button>
      </div>
    </div>
  );
};
